import React from 'react'
import { TouchableWithoutFeedback, View, Image, ImageStyle } from 'react-native'
import { useSelector } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'
import { useNavigation } from '@react-navigation/native'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text, Icon } from '@components/base'
import { cgmSteloImage } from '@src/assets/images'
import { AppStackParamList } from '@src/navigation/types'
import { useIsDarkMode } from '@src/config/theme'
import { Feature, useFeatureFlag } from '@src/components/FeatureFlag'
import { Analytics, CustomEventTypes } from '@src/config'
import { uiFlagsSelector } from '@src/selectors/uiFlags'

export const VideoCallsSteloUpsellPersistentPopup = () => {
  const uiFlags = useSelector(uiFlagsSelector)
  const theme = useTheme()
  const isDarkMode = useIsDarkMode()
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const videoCallsSteloUpsellEnabled = useFeatureFlag(Feature.VideoCallsSteloUpsell)

  const containerBackgroundColor = isDarkMode ? '#ffefd719' : theme['theme.marketing.lightYellow']
  const shouldShowSteloUpsellPersistentBanner =
    videoCallsSteloUpsellEnabled && uiFlags.showVideoCallSteloUpsellPersistentBanner

  if (!shouldShowSteloUpsellPersistentBanner) {
    return null
  }

  const handleOnPress = () => {
    Analytics.track(CustomEventTypes.VideoCallsSteloUpsellPersistentPopupPress)
    navigation.navigate('VideoCallsSteloUpsell')
  }

  return (
    <TouchableWithoutFeedback accessibilityLabel="Personalize My Plan" onPress={handleOnPress}>
      <View
        style={[
          styles.container,
          {
            backgroundColor: containerBackgroundColor,
            borderWidth: isDarkMode ? 1 : 0,
            borderColor: theme['theme.warning.lighter'],
          },
        ]}
      >
        <Image source={cgmSteloImage.imageSource} style={styles.image as ImageStyle} />

        <View style={{ flex: 1 }}>
          <Text type="large" bold style={styles.titleText}>
            Power your calls with Biosensor data
          </Text>
          <Text type="regular" style={styles.noteText}>
            Improve your understanding of how diet impacts your body
          </Text>
        </View>

        <Icon name="caret-right" size={18} style={styles.icon} />
      </View>
    </TouchableWithoutFeedback>
  )
}

const themedStyle = StyleService.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 8,
    padding: 16,
    borderRadius: 16,
    gap: 16,
    position: 'relative',
  },
  image: {
    width: 76,
    height: 68,
  },
  titleText: {
    color: 'theme.text.primary',
    maxWidth: 200,
  },
  icon: {
    position: 'absolute',
    top: 20,
    right: 12,
    color: 'theme.surface.base0',
  },
  noteText: {
    color: 'theme.text.secondary',
  },
})
